import { render, staticRenderFns } from "./NavigationView.vue?vue&type=template&id=4c9e82ec&scoped=true&"
import script from "./NavigationView.vue?vue&type=script&lang=js&"
export * from "./NavigationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e82ec",
  null
  
)

export default component.exports